import { RouteRecordRaw } from "vue-router";
import LoginView from "./views/LoginView.vue";
import CompleteAccountView from "./views/CompleteAccountView.vue";
import ForgotPasswordView from "./views/ForgotPasswordView.vue";
import ResetPasswordView from "./views/ResetPasswordView.vue";

export const authRoutes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "auth/login",
  },
  {
    path: "login",
    name: "login",
    component: LoginView,
  },
  {
    path: "complete-registration",
    name: "complete-registration",
    component: CompleteAccountView,
  },
  {
    path: "forgot-password",
    name: "forgot-password",
    component: ForgotPasswordView,
  },
  {
    path: "reset-password",
    name: "reset-password",
    component: ResetPasswordView,
  }
];
